import { Button, Stack } from "@mui/material";
import BackLink from "../../../shared/BackLink";
import { useState } from "react";
import RunManualDateBluVoucher from "./RunManualDateBluVoucher";
import RMFDataGrid from "../../../shared/data-grid/RMFDataGrid";
import { useDb } from "../../../../contexts/DatabaseContext";
import { useCollectionData } from "react-firebase-hooks/firestore";
import moment from "moment";

export default function BluVoucherReports() {
  const [manualOpen, setManualOpen] = useState(false);
  const { bluVoucherReportsCollection } = useDb();

  const [value, loading, error] = useCollectionData(
    bluVoucherReportsCollection
  );

  const rows =
    value &&
    value.map((row, index) => ({
      ...row,
      id: index,
      date: moment(row.created.toDate()).format("YYYY-MM-DD HH:mm"),
    }));

  const columns = [
    {
      field: "title",
      headerName: "File Name",
      width: 200,
      renderCell: (params) => {
        return (
          <Button
            href={params.row.url}
            target="_blank"
            rel="noopener noreferrer"
            variant="outlined"
            size="small"
          >
            {params.row.title}
          </Button>
        );
      },
    },
    { field: "date", headerName: "Report Date", width: 200 },
  ];

  return (
    <div>
      <h1>Blu Voucher Reports</h1>
      <BackLink />
      <Button
        color="primary"
        variant="contained"
        onClick={() => setManualOpen(true)}
      >
        Run Manual Date
      </Button>
      <br />
      <br />
      <Stack spacing={2}>
        {rows && <RMFDataGrid data={rows} columns={columns} />}
      </Stack>

      <RunManualDateBluVoucher
        open={manualOpen}
        close={() => setManualOpen(false)}
      />
    </div>
  );
}
